import styles from './styles.module.scss';
import {useTranslation} from 'react-i18next';
import {useCurrentSubscriptions} from 'ui/@hooks/queries/use-current-subscriptions';
import {useSafeCurrentCompanyUuid} from 'ui/@atoms/current-company';
import {Plans} from 'constants/plans';
import {differenceInDays, format} from 'date-fns';

const FreeTrailCard = () => {
  const {t} = useTranslation('components', {
    keyPrefix: 'sidebar-navigation.components.free-trail-card',
  });

  const companyUuid = useSafeCurrentCompanyUuid();

  const freeTrailSubscription = useCurrentSubscriptions({
    variables: {
      companyUuid,
    },
    select: (data) => {
      return data?.find(
        (subscription) => subscription.product.name === Plans.FREE_TRAIL_PLAN
      );
    },
  });

  if (!freeTrailSubscription.data) {
    return null;
  }

  // The backend's next_billing_date IS the trial end — deriving it
  // client-side from a hardcoded length drifts the moment the trial
  // duration changes server-side (it already did: 14 -> 30 days).
  const endDate = new Date(freeTrailSubscription.data.nextBillingDate);

  const remainingDays = differenceInDays(endDate, new Date());

  if (remainingDays < 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <p
        className={styles.title}
        dangerouslySetInnerHTML={{
          __html: t('title', {
            remainingDays:
              remainingDays > 1
                ? `${remainingDays} days`
                : `${remainingDays} day`,
            endsOn: format(endDate, 'MMMM dd'),
          }),
        }}
      />
    </div>
  );
};

export default FreeTrailCard;
